// extracted by mini-css-extract-plugin
module.exports = {"summaryTitle":"MainSettings_summaryTitle__2ISkZ"};